// reactStore/index.js
import { useHomeProductStore } from './homeProduct'
import { useEventStore } from './eventStore'

export const zStore = {
  homeProduct: useHomeProductStore,
  event: useEventStore
}



// WEBPACK FOOTER //
// ./src/react-component/reactStore/index.js